import { Mail } from "lucide-react";

/** Formats a build-injected YYYY-MM-DD (see craco.config.js lastUpdatedISO) as "September 6, 2026". */
export const formatLegalDate = (iso) => {
  const d = iso ? new Date(`${iso}T12:00:00Z`) : new Date();
  return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric", timeZone: "UTC" });
};

/**
 * LegalContactCard — one-line "questions? write to us" card at the top of
 * the legal pages so readers never have to scroll to the Contact section.
 */
export const LegalContactCard = ({ topic = "these terms", testid = "legal-contact-card" }) => (
  <div
    data-testid={testid}
    className="mt-6 flex flex-col gap-3 rounded-xl border border-border bg-bone px-5 py-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <p className="flex items-center gap-2.5 text-[13px] text-ink">
      <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-tangerine/15 text-tangerine">
        <Mail className="h-4 w-4" strokeWidth={2.2} />
      </span>
      Questions about {topic}? Write to us any time.
    </p>
    <a
      href={`mailto:hellofrom@myrichaunt.org?subject=Question%20about%20${encodeURIComponent(topic)}`}
      data-testid={`${testid}-email`}
      className="text-base font-semibold text-tangerine underline underline-offset-4 transition-colors hover:text-cobalt"
    >
      hellofrom@myrichaunt.org
    </a>
  </div>
);
